import { LoginCallback } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import CssApiClient from '../Components/Api';
import { useEffect } from 'react';

function LoginErrorHandler({ error }) {
  const navigate = useNavigate();

  useEffect(() => {
    const sendLog = async () => {
      const logPayload = {
        userAction: 'LOGIN_FAILED',
        errorMessage: error.error_description || error.error,
        statusCode: error.error === 'access_denied' ? 401 : 500,
      };

      try {
        await CssApiClient.postLog(logPayload);
      } catch (e) {
        console.error('Failed to send log', e);
      }

      if (error.error === 'access_denied' || error.errorCode === 'E0000006') {
        navigate('/no-access?reason=Access Denied');
      } else if (
        error.error === 'server_error' ||
        error.error === 'temporarily_unavailable'
      ) {
        navigate('/no-access?reason=Temporarily Okta Server Unavailable');
      }
    };
    sendLog();
  }, [error, navigate]);

  return null;
}

export default function CustomLoginCallback() {
  return <LoginCallback errorComponent={LoginErrorHandler} />;
}
